import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

ScrollTrigger.create({
  trigger: "body",
  start: "top+=50 top",
  onEnter: () => {
    gsap.to(".js-back-to-top", {
      display: "block",
      opacity: 1,
    });
  },
  onLeaveBack: () => {
    gsap.to(".js-back-to-top", {
      display: "none",
      opacity: 0,
    });
  },
});
